module.exports = __webpack_public_path__ + "static/mesh-large-mobile-b85c9323d7163ba0ac59c49b0cc96e60.svg";